import { useContext } from 'react'
import { ShardsContext } from 'contexts'
import { ShardMetadata } from 'api'
import { useInvokeApi, useShardApi } from '.'
import { considerDataToBeStale } from 'utils/pages'

interface Shards {
  initialize: () => Promise<void>
  shards: ShardMetadata[]
}

export const useShards = () => {
  const invokeApi = useInvokeApi()
  const { state, dispatch } = useContext(ShardsContext)
  const { getShards } = useShardApi()

  const initialize = async (): Promise<void> => {
    await loadShardMetadata()
  }

  const loadShardMetadata = async (): Promise<void> => {
    if (
      !considerDataToBeStale(state.shards, state.loadingState.lastApiReceiveAt)
    )
      return Promise.resolve()

    await invokeApi(
      () => getShards(),
      'There was an error loading database info',
      (result) => {
        dispatch({
          type: 'LoadShards',
          payload: result,
          timestamp: Date.now(),
        })
      },
    )
  }

  return {
    initialize: initialize,
    shards: state.shards,
  }
}
